<script lang="ts" setup>
import type {Publication} from "~/types/mgnl";
import ExternalLink from "~/assets/icons/external-link.svg";
import {getAssetLink} from "#magnolia-layer/utils/get-asset-link";

type Props = {
  publication: Publication;
};

const {publication} = defineProps<Props>();
const {t, locale} = useI18n();
const onOpenPublication = (publication: Publication) => {
  const link = getAssetLink(publication.media);
  if (link) {
    navigateTo(link, {
      external: true,
      open: {
        target: "_blank",
      },
    });
  }
};

const resolvedImage = didResolve(publication.cover) ? publication.cover : null;
const displayNames = computed(() => new Intl.DisplayNames(locale.value, { type: 'language' }));
</script>
<template>
  <div
    class="col-span-12 md:col-span-6 lg:col-span-4 flex flex-col gap-3 group cursor-pointer">
    <MagnoliaPicture
      v-if="resolvedImage"
      @click="onOpenPublication(publication)"
      class="*:w-full grayscale group-hover:grayscale-0"
      :auto-size="`width-${resolvedImage.metadata.width}`"
      :asset="resolvedImage"></MagnoliaPicture>
    <div class="flex flex-col gap-2 mt-5">
      <div
        class="uppercase text-2xl group-hover:text-sunrise-100 flex justify-between"
        @click="onOpenPublication(publication)">
        <div class="line-clamp-2">{{ publication.title }}</div>
        <div class="min-w-4 min-h-5 m-1">
          <ExternalLink class="text-base" />
        </div>
      </div>
      <div class="uppercase text-lg line-clamp-2">{{ publication.subtitle }}</div>
    </div>
    <div class="text-lg">{{ publication.description }}</div>
    <div class="border-t border-neutral-700"></div>
    <div class="flex flex-col gap-1">
      <div class="uppercase text-sm" v-if="publication.author">
        {{ publication.author?.authorName }}
      </div>
      <div class="uppercase text-sm">
        {{ t(`library.type.${publication.type}`) }}
      </div>
      <div class="uppercase text-sm">
        {{ displayNames.of(publication.language) }}
      </div>
    </div>
  </div>
</template>
